var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 12 13"}},[_c('circle',{attrs:{"cx":"6","cy":"6.5","r":"4.5","fill":"#fff","stroke":_vm.color,"stroke-width":"3"}})])}
var staticRenderFns = []

export { render, staticRenderFns }